import { PriceLegend as ShopPriceLegend } from '@shop/frontend/web/js/components/PriceLegend';
import { translator } from '@shop/frontend/web/js/services/TranslatorService';
import { helpers } from '@shop/frontend/web/js/helpers';

class PriceLegend extends ShopPriceLegend {
  /**
   * Создает легенды цен
   * @param zones {Array} [
   *   {zone, price, color, free, all}, ...
   * ]
   * @param params {Object} { showFreePlaces }
   */
  render(zones = [], params = {}) {
    this.$container.html('');

    const seatsEndings = [
      translator.t('event', 'seat'),
      translator.t('event', 'seats'),
      translator.t('event', 'seats '),
    ];

    if (params.joinEqualPrices) {
      const joinedZones = this.joinZonesByEqualPrices(zones);
      zones = Array.isArray(joinedZones) ? joinedZones.filter((i) => i.free > 0) : [];
    }

    zones.sort((a, b) => a.price - b.price);
    $.each(zones, (i, zone) => {
      const freeText = params?.isPlaces ? `, ${translator.t('main', 'free')} ${zone.free} ${helpers.wordEnding(
        zone.free,
        seatsEndings,
      )}` : `, ${translator.t('main', 'left')} ${zone.free} ${helpers.wordEnding(
        zone.free,
        seatsEndings,
      )}`;

      const legend = params?.isPlaces
        ? this.createPriceLegendPlacesByZone(zone, {
          usePrimaryColor: !!params.usePrimaryColor,
          freeText: params.showFreePlaces ? freeText : '',
        })
        : this.createPriceLegendSectorsByZone(zone, {
          usePrimaryColor: !!params.usePrimaryColor,
          freeText: params.showFreePlaces ? freeText : '',
        });

      this.$container.append(
        legend,
      );
    });

    if (!helpers.isDesktop.matches && params.mobileLastSlot) this.$container.append(params.mobileLastSlot);

    this.addListenerToInputs();
  }

  createPriceLegendSectorsByZone(zone, params = {}) {
    return `<label class="checkbox price-legend ${params.usePrimaryColor ? 'price-legend_primary' : ''}"">
              <input class="checkbox__input price-legend__input" type="checkbox" data-price="${zone.price}" data-zone-id="${zone.zone}"></span>
              <span class="${params.usePrimaryColor ? 'checkbox__custom' : ''}"></span>
              <span class="price-legend__content checkbox__block">
                  <span class="price-legend__color" style="background-color: ${zone.color}"></span>
                  <div class="price-legend__info">
                    <span class="price-legend__zone-name">${zone.name}</span>
                    <span class="price-legend__text">
                      ${translator.t('event', 'from')} ${`${zone.price} <span class="ruble">₽</span>` + `<span class="price-legend__text_free">${params.freeText ? params.freeText : ''}</span>`}
                    </span>
                  </div>
              </span >
            </label > `;
  }

  createPriceLegendPlacesByZone(zone, params = {}) {
    console.log(zone);
    return `<label class="checkbox price-legend ${params.usePrimaryColor ? 'price-legend_primary' : ''}"">
              <input class="checkbox__input price-legend__input" type="checkbox" data-price="${zone.price}" data-zone-id="${zone.zone}"></span>
              <span class="${params.usePrimaryColor ? 'checkbox__custom' : ''}"></span>
              <span class="price-legend__content checkbox__block">
                  <span class="price-legend__color" style="background-color: ${zone.color}"></span>
                  <span class="price-legend__text">
                    ${`${zone.price} <span class="ruble">₽</span>` + `<span class="price-legend__text_free">${params.freeText ? params.freeText : ''}</span>`}
                  </span >
              </span >
            </label > `;
  }
}

export default PriceLegend;
